/* istanbul ignore file */
import { fetch } from 'src/services/apollo-fetch';
import { apollo } from 'src/services/apollo-graphql';
import { Query, Mutation } from '../_api';

export default {
  async fetchManifests({ commit }) {
    const response = await fetch.query({
      query: Query.manifests,
    });
    commit('setManifests', response.data.manifests);
  },
  async fetchManifest(context, id) {
    const response = await fetch.query({
      query: Query.manifest,
      variables: { id },
    });
    return response.data.manifest;
  },
  async addManifest({ commit }, data) {
    const response = await fetch.mutate({
      mutation: Mutation.addManifest,
      variables: {
        input: data,
      },
    }, { showToast: true, message: 'Manifest added' });
    const newManifest = response.data.addManifest;
    commit('addManifest', newManifest);
    return newManifest;
  },
  async uploadDocument(context, data) {
    // Must use apollo.mutate directly instead of our custom
    // fetch.mutate because the omitDeep process corrupts the File object
    // and prevents it from being sent as a multipart form request
    // and instead sends it as json
    const response = await apollo.mutate({
      mutation: Mutation.uploadManifestDocument,
      variables: {
        input: data,
      },
    });
    return response.data.uploadManifestDocument;
  },
  async associateDocumentsWithManifest(context, data) {
    await fetch.mutate({
      mutation: Mutation.associateDocumentsWithManifest,
      variables: {
        input: data,
      },
    }, { showToast: false });
  },
  async deleteDocuments(context, data) {
    if (!data || !data.length) return;

    await fetch.mutate({
      mutation: Mutation.deleteManifestDocuments,
      variables: {
        documents: data,
      },
    }, { showToast: false });
  },
  async updateManifest({ commit }, data) {
    const response = await fetch.mutate({
      mutation: Mutation.updateManifest,
      variables: {
        input: data,
      },
    }, { showToast: false });
    const updatedManifest = response.data.updateManifest;
    commit('updateManifest', updatedManifest);
  },
};
